module.exports = __webpack_public_path__ + "img/112.3f2e351e.jpg";